import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdateRegistrationCutoffResult {
  updateRegistrationCutoff: {
    event: {
      id: number;
      registrationCutoffAt: string | null;
      isPastRegistrationCutoff: boolean;
      questionnaireCutoffAt: string | null;
    };
    ok: boolean;
  };
}

export interface UpdateRegistrationCutoffVariables {
  input: {
    eventId: number;
    registrationCutoffAt?: string | null;
  };
}

const UpdateRegistrationCutoffMutation = gql`
  mutation UpdateRegistrationCutoff($input: UpdateRegistrationCutoffInputType!) {
    updateRegistrationCutoff(input: $input) {
      ok
      event {
        id
        registrationCutoffAt
        isPastRegistrationCutoff
        questionnaireCutoffAt
      }
    }
  }
`;

export const updateRegistrationCutoff = (
  variables: UpdateRegistrationCutoffVariables
): Promise<UpdateRegistrationCutoffResult> => {
  return gqlClient.request<UpdateRegistrationCutoffResult>(
    UpdateRegistrationCutoffMutation,
    variables
  );
};
